import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=1ccb6d20&scoped=true&"
import script from "./Request.vue?vue&type=script&lang=js&"
export * from "./Request.vue?vue&type=script&lang=js&"
import style0 from "./Request.vue?vue&type=style&index=0&id=1ccb6d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccb6d20",
  null
  
)

export default component.exports
import {QBtn,QTooltip,QDialog,QCard,QToolbar,QToolbarTitle,QScrollArea,QCardSection} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip,QDialog,QCard,QToolbar,QToolbarTitle,QScrollArea,QCardSection}, component.options.components || {})
